import { updateLinksAttributes } from '../../utils/handleAttributes';

export default function seoWidget() {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomSeo(data.items, $widget);
      } else {
        $('body').addClass('seoWidget-no-data');
        $widget.remove();
      }
    },
  });
}

function createCustomSeo(widgetData, $widget) {
  const $seo = $widget.find('.card-widget-item');
  const { Title, Description, URL } = widgetData[0];

  $seo.replaceWith(`
    <h1 class="seo-title">${Title}</h1>
    <div class="seo-description">${Description}</div>
  `);

  const firstHeadline = $widget.find('.seo-title span:nth-child(1)').text();
  const secondHeadline = $widget.find('.seo-title span:nth-child(2)').text();

  $widget.find('.seo-title').attr('aria-label', (firstHeadline + ' ' + secondHeadline).trim());

  if (URL == null || URL === '') {
    return;
  }

  const linkAriaLabel = `Learn more about ${secondHeadline}`;
  const linkAttributes = updateLinksAttributes(URL, linkAriaLabel);

  $widget.append(
    `<a href="${URL}" class="button alternative-btn" ${linkAttributes}>Learn More</a>`,
  );
}
